import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Title } from '@angular/platform-browser'
import { zip } from 'rxjs'

import { ReservationService } from 'app/shared/reservation/reservation.service'
import { SnapshotService } from 'app/shared/snapshot.service'
import { ResourceService } from 'app/shared/resources/resource.service'
import { TpaService } from 'app/tpa/tpa.service'
import { ITpaCategory, ITpaItemSelection } from 'app/tpa/tpa.interfaces'
import { AmendService } from 'app/shared/reservation/amend.service'
import { hashObject } from 'app/shared/utils'
import { LayoutState } from '../../shared/layout/layout-state'
import { TrackingAmendmentStep } from '../../shared/tracking/tracking-wire.interfaces'
import { TrackingService } from '../../shared/tracking/tracking.service'

@Component({
    selector: 'sbw-amendment-tpa',
    templateUrl: './amendment-tpa.component.html',
    styleUrls: ['./amendment-tpa.component.css']
})
export class AmendmentTpaComponent implements OnInit {
    public reservationCode: string
    public currencyCode: string
    public tpaCategories: ITpaCategory[]
    public selections: ITpaItemSelection[] = []
    public errors: string[] = []
    tpasChanged = false
    private initialMd5
    public isAgent: boolean

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private reservationService: ReservationService,
        private snapshotService: SnapshotService,
        private resourceService: ResourceService,
        private tpaService: TpaService,
        private amendService: AmendService,
        private title: Title,
        private trackingService: TrackingService,
        private layoutState: LayoutState
    ) { }

    ngOnInit() {
        this.isAgent = localStorage.getItem('sbw_AgentGenericId') ? true : false;
        let reservationCode = this.route.snapshot.params['reservationCode'];
        this.reservationCode = reservationCode
        let tpa$ = this.tpaService.getTpaAmendment(reservationCode)
        let reservation$ = this.reservationService.getReservation(reservationCode)
        zip(tpa$, reservation$).subscribe(arr => {
            let [tpa, reservation] = arr
            this.loadResources(tpa.routeCode, tpa.locale)
            this.currencyCode = tpa.currency
            this.tpaCategories = tpa.categories
            this.tpaService.setSelectionsOnViewModel(this.tpaCategories, tpa.selections)
            this.selections = this.tpaService.getSelections(this.tpaCategories)
            this.enrichReservation()
            this.initialMd5 = hashObject(this.selections)
            this.trackingService.trackAmendment(TrackingAmendmentStep.TPA, false, reservation)
            this.layoutState.setIsContentLoaded(true)
        })
    }

    public tpasChangedHandler() {
        this.selections = this.tpaService.getSelections(this.tpaCategories)
        this.tpasChanged = hashObject(this.selections) !== this.initialMd5
    }

    private enrichReservation() {
        let snapshot = this.snapshotService.getSnapshot(this.reservationCode)
        if (snapshot && snapshot.tpas) {
            this.selections = snapshot.tpas
            this.tpaService.setSelectionsOnViewModel(this.tpaCategories, this.selections)
            this.tpaService.updateIsOpen(this.tpaCategories)
        }
    }

    private loadResources(routeCode: string, locale: string): void {
        this.resourceService.loadResources(routeCode, locale, ['Common', 'Amendment', 'ArrangementOptions', 'Currency', 'Quote'].concat(this.isAgent ? ['Agent', 'MenuAgent'] : []))
        this.resourceService.get('ARRANGEMENT_OPTIONS_TITLE', false).subscribe(s => this.title.setTitle(s));
    }

    public continue() {
        this.layoutState.setIsContentLoaded(false)
        const dryRun = true
        this.amendService.changeTpas(this.reservationCode, this.selections, dryRun)
            .subscribe(response => {
                if (response.errorMsgs && response.errorMsgs.length) {
                    this.errors = response.errorMsgs.map(m => m.message)
                    this.layoutState.setIsContentLoaded(true)
                    return
                }
                this.snapshotService.setSnapshot(this.reservationCode, { tpas: this.selections })
                this.navigateBack()
            })
    }

    navigateBack() {
        this.router.navigate(['/amendment/booking', this.reservationCode])
    }
}
